import React, { useState, useEffect } from "react";
import { Card, Avatar, Row, Col } from "antd";
// import { Button } from "@digitallabs/one-x-ui";
import { Button } from "../../resourses/digitallabs/one-x-ui";
import { CheckCircleFilled, DownOutlined, UserOutlined, UpOutlined } from "@ant-design/icons";
import "../../styles/SystemFetchDetails.css";
import { saveCurrentInternalStep, setEditingMode } from "../../utils/formStorage";
import { generalMaskString, maskingUtil } from "../../utils/maskingUtil";
import { MAIN_STEPS } from "../../constants/constants";

const SystemFetchDetails = ({ systemDetails, expanded, confirmationPage = false, handleStepChange, handleToggle }) => {
  const [windowWidth, setWindowWidth] = useState(typeof window !== "undefined" ? window.innerWidth : 0);
  const breakPoint = 620;

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    if (typeof window !== "undefined") {
      setWindowWidth(window.innerWidth);
      window.addEventListener("resize", handleResize);
    }

    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", handleResize);
      }
    };
  }, []);

  const handleEditInfo = () => {
    setEditingMode(true);
    saveCurrentInternalStep(1);
    handleStepChange(MAIN_STEPS.PERSONAL_DETAILS);
  };

  const SummaryRow = ({ colspan = 12, label, value }) => (
    <Col xs={colspan} sm={colspan} md={colspan} lg={colspan} xl={colspan}>
      <label className="summary-label">{label}</label>
      <div>
        <label className="summary-value">{value || "-"}</label>
      </div>
    </Col>
  );

  return (
    <Card className="system-fetch-card" style={{ padding: 0 }}>
      {!confirmationPage && (
        <div className="success-bar">
          <CheckCircleFilled className="success-icon" />
          <span>Details have been fetched from system.</span>
        </div>
      )}

      <div className="info-row" onClick={handleToggle}>
        <Avatar size={50} icon={<UserOutlined />} />
        <div className="info-text">
          <div className="name">{systemDetails?.name}</div>
          <div className="details">
            Emp {systemDetails?.empCode} | {systemDetails?.gender}
          </div>
        </div>
        {expanded ? <UpOutlined className="arrow-system-icon" /> : <DownOutlined className="arrow-system-icon" />}
      </div>

      {expanded && (
        <div className="expanded-content">
          <Row gutter={16}>
            <SummaryRow label="Master Policy Holder Name" value={systemDetails?.corpName} />
            <SummaryRow label="Master Policy Number" value={systemDetails?.corpPolicy ? generalMaskString(systemDetails?.corpPolicy) : null} />
            <SummaryRow colspan={24} label="Email Id" value={systemDetails?.email ? maskingUtil("email", systemDetails.email) : null} />
            <SummaryRow label="Phone no" value={systemDetails?.mobile ? generalMaskString(systemDetails?.mobile) : null} />
            <SummaryRow label="Gender" value={systemDetails?.gender} />

            {confirmationPage && (
              <>
                <SummaryRow label="Nationality" value={systemDetails?.nationality} />
                <SummaryRow label="Maritial Status" value={systemDetails?.maritialStatus} />
                <SummaryRow label="Education" value={systemDetails?.education} />
                <SummaryRow label="Occupation" value={systemDetails?.occupation} />
                <SummaryRow label="Designation" value={systemDetails?.designation} />
                {/* <SummaryRow label="Nature of Business" value={systemDetails?.occupationNature} /> */}
                <SummaryRow label="Height" value={systemDetails?.height ? `${systemDetails?.height} cms` : null} />
                <SummaryRow label="Weight" value={systemDetails?.weight ? `${systemDetails?.weight} kgs` : null} />
              </>
            )}
          </Row>

          {confirmationPage && (
            <>
              <br />

              <Button size="sm" variant="secondary" fullWidth onClick={handleEditInfo}>
                Edit Information
              </Button>
            </>
          )}
        </div>
      )}
    </Card>
  );
};

export default SystemFetchDetails;
